var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudienceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 46,
    viewBox: "0 0 63 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9996 20.3659C56.9996 24.5297 53.6417 27.9054 49.4998 27.9054C45.3578 27.9054 41.9999 24.5297 41.9999 20.3659C41.9999 16.2016 45.3578 12.8259 49.4998 12.8259C53.6417 12.8259 56.9996 16.2016 56.9996 20.3659Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9995 20.3659C20.9995 24.5297 17.6416 27.9054 13.4996 27.9054C9.35768 27.9054 5.99976 24.5297 5.99976 20.3659C5.99976 16.2016 9.35768 12.8259 13.4996 12.8259C17.6416 12.8259 20.9995 16.2016 20.9995 20.3659Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0005 11.3184C42.0005 17.1478 37.2991 21.8735 31.5002 21.8735C25.7014 21.8735 21 17.1478 21 11.3184C21 5.4885 25.7014 0.762695 31.5002 0.762695C37.2991 0.762695 42.0005 5.48837 42.0005 11.3184Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9337 30.9207C52.8749 33.9666 53.9999 37.5887 53.9999 41.4763V44.492C53.9999 45.0216 53.91 45.528 53.7433 46.0001H61.4998C61.8976 46.0001 62.2797 45.8416 62.5605 45.5583C62.8423 45.2761 63 44.8919 63 44.492V41.4763C63 35.6468 58.2991 30.9207 52.4997 30.9207H50.9337Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5001 46.0002H13.4998C12.6716 46.0002 11.9996 45.3247 11.9996 44.4921V41.4764C11.9996 32.3158 19.3875 24.8896 28.5006 24.8896H34.5003C43.6129 24.8896 51.0013 32.316 51.0013 41.4764V44.4921C51.0013 45.3247 50.3293 46.0002 49.5011 46.0002H49.5001Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0663 30.9207H10.5002C4.70099 30.9207 0 35.6468 0 41.4763V44.492C0 44.8919 0.157707 45.2761 0.43946 45.5583C0.720211 45.8416 1.1024 46.0001 1.50018 46.0001H9.25669C9.08995 45.528 9.00005 45.0216 9.00005 44.492V41.4763C9.00005 37.5887 10.1251 33.9666 12.0663 30.9207Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudienceIcon);
export default __webpack_public_path__ + "static/media/audienceIcon.b72b8c808ca1d7257d0d3acc9f22f92c.svg";
export { ForwardRef as ReactComponent };